// PWA Service Worker kaydı
export function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then(() => console.log("PWA: Service Worker kayıtlı"))
        .catch((err) => console.log("PWA: Service Worker kayıt hatası", err));
    });
  }
}
